// extracted by mini-css-extract-plugin
export default {"container":"staticPages_container__iPDV-","divider":"staticPages_divider__R0csS"};